import { configureStore } from "@reduxjs/toolkit";
import storage from "redux-persist/lib/storage";
import rootReducer from "./RootReducer";
import autoMergeLevel2 from 'redux-persist/lib/stateReconciler/autoMergeLevel2';
import { FLUSH, PAUSE, PERSIST, PURGE, REGISTER, REHYDRATE, persistReducer, persistStore } from "redux-persist";
import { tokenMiddleware } from "../utils/apiUtils/tokenMiddleware";
import { stripSensitiveDocumentDataTransform } from "./persistTransforms";


export const localpersistConfig = {
    key: "root",
    storage,
    whitelist: ["App", "companyAdmin", "Employee", "superAdmin"],
    stateReconciler: autoMergeLevel2,
    transforms: [stripSensitiveDocumentDataTransform],
};

const persistedReducer = persistReducer(localpersistConfig, rootReducer);

export const store = configureStore({
    reducer: persistedReducer,
    middleware: getDefaultMiddleware => getDefaultMiddleware({
        serializableCheck: {
            ignoreActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER]
        },
    }).concat(tokenMiddleware),
});

export const persistor = persistStore(store);

